// ⚠ SS2B-2a — derive a StatusBadge key (one the shared StatusBadge switch ALREADY handles) from the
// native workflow_status + closure_reason, so StatusBadge stays untouched + ORA-safe. StatusBadge gains
// exactly 2 new additive cases (`withdrawn`, `replaced_by_renewal`); the neutral-resolution closures fall
// to StatusBadge's `default → muted`. ⚠ Params are widened to `string` because RenewalLineageEntry
// carries workflow_status/closure_reason as string (slim lineage row); the switches are literal-safe.
export function rrBadgeStatus(
  workflow_status: string,
  closure_reason: string | null,
): string {
  // non-closed statuses map 1:1 (draft/pending_approval/returned/approved/denied/withdrawn).
  if (workflow_status !== 'closed') return workflow_status;
  switch (closure_reason) {
    case 'remediated': return 'closed_mitigated';       // emerald — reuses the existing positive-closure case
    case 'expired':    return 'expired';                // rose
    case 'revoked':    return 'revoked';                // rose
    case 'replaced_by_renewal': return 'replaced_by_renewal'; // NEW neutral case (superseded, not a failure)
    default:           return 'closed';                 // app_service_retired/no_longer_applicable/other/null → muted (default)
  }
}
